"use strict";
class BrowserDetector {
}
BrowserDetector.IsOpera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
BrowserDetector.IsChrome = navigator.userAgent.indexOf('Chrome') > -1 && !BrowserDetector.IsOpera;
BrowserDetector.IsExplorer = navigator.userAgent.indexOf('MSIE') > -1;
BrowserDetector.IsFirefox = navigator.userAgent.indexOf('Firefox') > -1;
BrowserDetector.IsSafari = navigator.userAgent.indexOf("Safari") > -1 && !BrowserDetector.IsChrome;
BrowserDetector.IsEdge = navigator.userAgent.indexOf("Edge") > -1;
window.BrowserDetector = BrowserDetector;
